import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const homesTableTooltips = TOOLTIPS_TEXTS.homeLoginsTable;

export const BASE_HOME_LOGINS_OPTIONS: TableOption[] = [
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOME_LOGINS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'type', 'email', 'phone', 'status', 'lastLoginDate', 'options'],
  displayedTitles: ['Name', 'Type', 'Email', 'Phone', 'Status', 'Last Logged In', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    homesTableTooltips.name,
    homesTableTooltips.type,
    homesTableTooltips.email,
    homesTableTooltips.phone,
    homesTableTooltips.status,
    homesTableTooltips.lastLoggedIn
  ],
  options: null,
  dataSource: []
};
